import React from 'react';
import PropTypes from 'prop-types';
import Lightbox from '../lightbox/lightbox';
import { DriverReviewLightBoxHeader } from './driver_review_light_box_header';
import { DriverReviewLightBoxContent } from './driver_review_light_box_content';
import getTranslatedText from '../../helper/get_translated_text';

function DriverReviewLightBox(props) {
    const title = getTranslatedText('pdp-reviews');

    return (
        <Lightbox
            opened={props.visible}
            onClose={props.onClose}
            additionalClassNames={['driver-review-lightbox']}
            headerIcon="icon-fitting bg-primary"

        >
            <div className="cross-sell-light-box1" style={{ minWidth: '360px' }}>
                <DriverReviewLightBoxHeader title={title} />
                <DriverReviewLightBoxContent
                    data={props.data || {}}
                    visible={props.visible}
                    LightBoxVisible={props.LightBoxVisible}
                    onClose={props.onClose}
                />
            </div>
        </Lightbox>
    );
}

DriverReviewLightBox.propTypes = {
    visible: PropTypes.bool.isRequired,
    LightBoxVisible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export { DriverReviewLightBox };
